<template>
  <div class="assessment-form">
    <header class="assessment-header">
      <HeaderText tag="h2"><slot name="header"/></HeaderText>
      <div v-if="$slots.description" class="description">
        <slot name="description" />
      </div>
    </header>
    <form @submit.prevent="onSubmit" class="form-step">
      <div class="form-fields">
        <slot />
      </div>
      <BaseButton
        :variant="showSkip ? 'default' : 'primary'"
        class="submit-btn"
        :disabled="disabled"
      >
        {{ showSkip ? 'Skip' : submitCta }}
      </BaseButton>
    </form>
  </div>
</template>

<script>
import BaseButton from '@/components/base-button';
import HeaderText from '@/components/header-text';

export default {
  components: { BaseButton, HeaderText },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showSkip: {
      type: Boolean,
      default: false,
    },
    submitCta: {
      type: String,
      default: 'Next',
    },
  },
  methods: {
    onSubmit(e) {
      if (this.disabled) return;
      this.$emit('submit', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.assessment-form {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.assessment-header {
  text-align: center;
}

.description {
  color: var(--white-transparent);
  font-size: 18px;
  max-width: 580px;
  margin: 0 auto;
}

.form-step {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: 100%;
    width: 542px;
  }
}

.form-fields {
  margin: 48px 0;
}

.submit-btn {
  margin-top: auto;
}
</style>
